<template>
  <div id="app">
    <keep-alive>
	    <router-view v-if="$route.meta.keepAlive"></router-view>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  }
};
</script>

<style>
@import url('./assets/css/common.css');
.drow-select{
  position: absolute;
  width: 100%;
  padding: 4px;
  z-index: 99999;
  top: 42px;
  right: 0px;
  border-radius: 0 0.4em 0.4em 0.4em;
  background: rgba(0,0,0,0.5)
}
.drow-select:after{
  content: "";
  position: absolute;
  width: 10px;
  height: 3px;
  z-index: 99999;
  top: -3px;
  left: calc( 50% - 5px );
  border-radius:4em 4em  0 0 ;
  background: rgba(0,0,0,0.5)
}
.drow-select .row{
  border-top: 1px solid rgba(255,255,255,0.5);
  padding-top: 4px;
  padding-bottom: 4px;
}
.drow-select .row:first-child{
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue